import Enchante121 from '../../../Media/BSD/Enchante/Enchante 15 (2).webp'
import Enchante122 from '../../../Media/BSD/Enchante/Enchante 15 (2).webp'





const Enchante12images =[ Enchante121,Enchante122
]

export default Enchante12images;